/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The alarm state:
 *   * RAISED: the alarm has been raised and is still active
 *   * RAISED_ACKNOWLEDGED: the alarm has been raised and is already acknowledged
 *   * RESETED: raised alarm has been just reseted
 *   * RESETED_ACKNOWLEDGED: raised alarm has been acknowledged and reseted
 */
export enum AlarmState {
  RAISED = 'RAISED',
  RAISED_ACKNOWLEDGED = 'RAISED_ACKNOWLEDGED',
  RESETED = 'RESETED',
  RESETED_ACKNOWLEDGED = 'RESETED_ACKNOWLEDGED'
}
